export default "__VITE_ASSET__CKhewAI3__"